module.exports = __webpack_public_path__ + "img/four-disabled-big.7351e84b.svg";